import { useContext } from "react";

import { useQuery } from "@apollo/client";
import { useParams } from "react-router";

import { PageLoadingIndicator } from "@/components/nav/PageLoading";
import PageContainer from "@/components/pages_flexible/PageContainer";
import { NotFound } from "@/components/pages_public/404";
import { ResponseContext } from "@/components/ResponseContext";
import { ArticleSeriesDocument } from "@/graphql";
import {
  IsLoggedInQuery,
  SSRAlgoliaResultsQuery,
} from "@/graphql/cachedVarsQueries";

import ArticleSeriesPage from "./ArticleSeriesPage";

export default function ArticleSeriesContainer() {
  const { res } = useContext(ResponseContext);
  const { slug } = useParams();

  const { data: articleSeriesData, loading } = useQuery(ArticleSeriesDocument, {
    variables: {
      slug,
    },
  });

  const { data: ssrData } = useQuery(SSRAlgoliaResultsQuery);

  const { data: loggedInData } = useQuery(IsLoggedInQuery);

  if (!articleSeriesData && loading) {
    return (
      <PageContainer
        maxWidth="100%"
        layout="learnArticle"
        contentType="roleplay"
      >
        <PageLoadingIndicator
          type="learnArticle"
          visibleSideNav={loggedInData?.isLoggedIn}
        />
      </PageContainer>
    );
  }

  if (
    !loading &&
    (!articleSeriesData ||
      !articleSeriesData.articleSeries ||
      !articleSeriesData.articleSeries.title)
  ) {
    if (res) {
      res.status(404);
    }
    return (
      <PageContainer maxWidth="100%" layout="full">
        <NotFound />
      </PageContainer>
    );
  }

  const articleSeries = articleSeriesData.articleSeries;
  const parsedSsrData =
    ssrData && ssrData.algoliaData && JSON.parse(ssrData.algoliaData);
  const articlesData = parsedSsrData ? parsedSsrData.articlesResult || {} : {};

  return (
    <ArticleSeriesPage
      articlesData={articlesData}
      articleSeries={articleSeries}
    />
  );
}
